var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 10 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M4.928 0C3.094 0 1.603 1.491 1.603 3.325C1.603 5.124 3.01 6.58 4.844 6.643C4.9 6.636 4.956 6.636 4.998 6.643C5.012 6.643 5.019 6.643 5.033 6.643C5.04 6.643 5.04 6.643 5.047 6.643C6.839 6.58 8.246 5.124 8.253 3.325C8.253 1.491 6.762 0 4.928 0Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.48397 8.50506C6.53097 7.20306 3.34597 7.20306 1.37897 8.50506C0.489969 9.10006 -3.05176e-05 9.90506 -3.05176e-05 10.7661C-3.05176e-05 11.6271 0.489969 12.4251 1.37197 13.0131C2.35197 13.6711 3.63997 14.0001 4.92797 14.0001C6.21597 14.0001 7.50397 13.6711 8.48397 13.0131C9.36597 12.4181 9.85597 11.6201 9.85597 10.7521C9.84897 9.89106 9.36597 9.09306 8.48397 8.50506Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }